import { useUIState } from "../../hooks/uiHooks"
import { Modal } from "../modal/modal"
import { ModalId } from "../modal/types"
import { Validatable } from "../validatable/validatable"

type Props = {
    title: string
    widthSize?: 's' | 'm' | 'l'
    submitLabel?: string
    closeable?: boolean
    onSubmit?: () => void
    onCancel?: () => void
}

export const ValidationModal2 = (props: Props) => {
    const { title, widthSize, submitLabel, closeable, onSubmit, onCancel } = props

    const { modalValidations } = useUIState()

    return (
        <Modal
            modalId={ModalId.VALIDATION}
            title={title}
            submitLabel={submitLabel}
            cancelLabel="Cerrar"
            widthSize={widthSize}
            closeable={closeable}
            hideCancel={!closeable}
            onSubmit={onSubmit}
            onCancel={onCancel}
        >
            <Validatable validations={modalValidations} expanded />
        </Modal>
    )
}
